import React from 'react';
import { StatusTagState } from '@innersource-nn/novoui-react/dist/external-lib/NStatusTag/NStatusTagProps';
import { ExternalIconNames } from '@innersource-nn/novoui-react/dist/external-lib/NIcon/icons';
import { NovoIconNames } from '@novonordisk/novoui-vuejs';
import { DataClassificationsOptions } from 'types/Dataset';

export interface ClassificationProps {
    icon?: NovoIconNames | ExternalIconNames;
    state: StatusTagState;
    label: DataClassificationsOptions;
}
export const classificationsOptions = [
    {
        label: DataClassificationsOptions.Public,
        value: 'C1',
    },
    {
        label: DataClassificationsOptions.InternalUse,
        value: 'C2',
    },
    {
        label: DataClassificationsOptions.Confidential,
        value: 'C3',
    },
    {
        label: DataClassificationsOptions.StrictlyConfidential,
        value: 'C4',
    },
];

export function getClassificationProps(
    confidentiality: string,
): ClassificationProps {
    switch (confidentiality) {
        case 'C1':
            return {
                icon: 'success',
                state: 'info',
                label: DataClassificationsOptions.Public,
            };
        case 'C2':
            return {
                icon: 'success',
                state: 'info',
                label: DataClassificationsOptions.InternalUse,
            };
        case 'C3':
            return {
                icon: 'circleRemove',
                state: 'warning',
                label: DataClassificationsOptions.Confidential,
            };
        case 'C4':
            return {
                icon: 'circleRemove',
                state: 'alert',
                label: DataClassificationsOptions.StrictlyConfidential,
            };
        default:
            return {
                icon: 'success',
                state: 'info',
                label: DataClassificationsOptions.InternalUse,
            };
    }
}

export default function DatasetClassificationTooltip() {
    return (
        <div className="flex flex-col gap-8">
            <div>Select the correct data classification for your dataset:</div>
            <div>
                <b>Public:</b> Freely accessible with no restrictions.
            </div>
            <div>
                <b>Internal use:</b> May cause minor harm if misused.
            </div>
            <div>
                <b>Confidential:</b> May cause moderate to major harm if
                misused.
            </div>
            <div>
                <b>Strictly confidential:</b> May cause critical harm if
                misused.
            </div>
        </div>
    );
}
